export default "__VITE_ASSET__COVBDrt8__"